import * as React from 'react';
import { IChild } from '../../../../share/types/case/children';
import { IAbductor } from '../../../../share/types/case/abductor';
import { PersonLayout } from '../layouts/TransferCase';

export interface IPersonInfoFormProps {
  type: string;
  personsInfo: Array<IChild | IAbductor>;
  form: (name: string, required?: boolean) => void;
  setValue: (path: string, value: any) => void;
  disabled: boolean;
};

export interface IPersonInfoFormState {
  currentArray: string;
  isChild: boolean;
};

export class TransferInfoForm extends React.Component<IPersonInfoFormProps, IPersonInfoFormState> {
  constructor(props: IPersonInfoFormProps) {
    super(props);

    this.state = {
      currentArray: this.props.type === 'child' ? 'children' : 'abductors',
      isChild: this.props.type === 'child'
    };
  }

  public render() {
    const personsInfoTyped: Array<IChild | IAbductor> = this.props.personsInfo;
    return (
      <div className={"margin-forms"}>
        {personsInfoTyped.map((person: IChild | IAbductor, i: number) => <PersonLayout key={`${this.props.type}-${i}`} that={this} person={person} index={i} />)}
      </div>
    );
  }
  
  public form(id: number, key: string, required = true) {
    return this.props.form(`${this.state.currentArray}[${id}].${key}`, required)
  }

}

export default IPersonInfoFormProps;
